import styled from 'styled-components'

export const ActionContainer = styled.div`
    position: absolute;
    right: 10%;
    border: 1px solid #000000;
    border-radius: 16px 0px 16px 16px;
    box-shadow: 0px 8px 16px rgba(0, 0, 0, 0.1);
    background-color: #FFFFFF;
    z-index: 1;
`
